<template>
  <!-- style="margin-top: -30px" -->
  <br>
  <br>





</template>

<script>
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';

import axios from 'axios';
import { defineComponent } from 'vue';
export default defineComponent({
  name: "FeedBack",
  components: {
    LeftCircleOutlined,
    RightCircleOutlined,
  },
  data() {

    return {




    }
  },
  methods: {


  },

});
</script>

<style scoped>






</style>
